import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { RouteCMRAgentActionsDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentActionsDto';
import { AlertService, SharedExternalCMRAgentPoliceQRComponent } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-cmr-agent-actions-policeinspection',
    templateUrl: './shared.external.cmr.agent.actions.policeinspection.component.html',
    styleUrls: ['./shared.external.cmr.agent.actions.policeinspection.component.scss']
})
export class SharedExternalCMRAgentActionsPoliceInspectionComponent implements OnInit {


    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteController: OpenRouteController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
    }

    public __value: RouteCMRAgentActionsDto;
    @Input()
    public set value(value: RouteCMRAgentActionsDto) {
        if (this.__value === value)
            return;
        this.__value = value;
        this.wellcome()
    }
    public get value(): RouteCMRAgentActionsDto {
        return this.__value;
    }

    public wellcome() {

    }

    public executeAsPolice: boolean;
  
    public optionExpanded: string;
    public onOptionExpandedChanged(option: string){
        this.optionExpanded = option;
    }

    
    @ViewChild(SharedExternalCMRAgentPoliceQRComponent) policeComponent: SharedExternalCMRAgentPoliceQRComponent;
   
    public collapse(): boolean {
        if (this.optionExpanded) {
            this.optionExpanded = "";
            return true;
        }
        if(this.executeAsPolice){
            if(this.policeComponent?.collapse())
                return true;
            this.executeAsPolice = false;
            return true;
        }

        return false;
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
